import "./WalletUSDTPage.scss";
import { ChooseTab } from "./components";

const WalletUSDTPage = () => {
  return (
    <div className="walletUSDTPageContainer px-3">
      <ChooseTab />
    </div>
  );
};

export default WalletUSDTPage;
